import { __rest } from 'tslib';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { styled, alpha } from '@mui/material';
import { usePopupState, bindHover } from 'material-ui-popup-state/hooks';
import { noop } from 'lodash';
import { ReactComponent as ForwardRef } from '../../../assets/icons/ArrowRightSmall.svg.js';
import { useOverflow } from '../OverflowProvider.js';
import CascadingMenu from './CascadingMenu.js';
import MenuItem from './MenuItem.js';
import { useCascading } from './CascadingProvider.js';

const TRANSFORM_ORIGIN = { vertical: 'top', horizontal: 'left' };
const ANCHOR_ORIGIN = { vertical: 'top', horizontal: 'right' };
const _MenuItem = styled(MenuItem) `
  justify-content: space-between;
`;
const ArrowIcon = styled(ForwardRef) `
  ${({ theme }) => `margin: ${theme.spacing(0)} !important;`}
`;
const _CascadingMenu = styled(CascadingMenu, { shouldForwardProp: prop => !['dense'].includes(prop) }) `
  ${({ theme, dense }) => `
    margin: ${theme.spacing(dense ? -1 : -2, 0, 0, 0)};
    .MuiMenu-paper {
      padding: ${theme.spacing(0, 0, 0, 1)};
      background-image: none;
      box-shadow:: none;
    }
    .MuiList-root {
      border-radius: 3px;
      box-shadow: 0 5px 5px -3px ${alpha('#000', 0.2)},
        0 8px 10px 1px ${alpha('#000', 0.14)},
        0 3px 14px 2px ${alpha('#000', 0.12)};
    }
  `}
`;
const SubMenuItem = (_a) => {
    var { children, label, disabled, transformOrigin = TRANSFORM_ORIGIN, anchorOrigin = ANCHOR_ORIGIN } = _a, rest = __rest(_a, ["children", "label", "disabled", "transformOrigin", "anchorOrigin"]);
    const { dense } = useOverflow();
    const { parentPopupState } = useCascading();
    const popupState = usePopupState({
        popupId: `${label}-submenu`,
        variant: 'popover',
        parentPopupState,
    });
    const onMouseLeaveCascadingChild = useCallback((event) => {
        if (!popupState.anchorEl) {
            popupState.onMouseLeave(event);
        }
        else {
            noop();
        }
    }, [popupState]);
    return (jsxs(Fragment, { children: [jsx(_MenuItem, Object.assign({}, rest, { disabled: disabled, dense: dense }, (!disabled && Object.assign({}, bindHover(popupState))), { rightIcon: jsx(ArrowIcon, {}), preventMenuClose: true }, { children: label })), jsx(_CascadingMenu, Object.assign({ transformOrigin: transformOrigin, anchorOrigin: anchorOrigin, dense: dense, popupState: popupState, onMouseLeave: onMouseLeaveCascadingChild }, { children: children }))] }));
};

export { SubMenuItem as default };
//# sourceMappingURL=SubMenuItem.js.map
